// extracted by mini-css-extract-plugin
module.exports = {"longReportModal":"LongReportModal_longReportModal__1ySLT","closeButton":"LongReportModal_closeButton__3Zpav","buttons":"LongReportModal_buttons__bm3Nh"};